import pick from 'lodash.pick';
import {
  CustomizeRequest,
  DoorsRequest,
  MakeRequest,
  ModelVersionRequest,
  ParentModelRequest,
  TrimRequest,
  YearRequest
} from '~/contracts/new-cars';

export default function pickRequestProps(
  request:
    | CustomizeRequest
    | DoorsRequest
    | MakeRequest
    | ModelVersionRequest
    | ParentModelRequest
    | TrimRequest
    | YearRequest
) {
  return pick(request, [
    'doorCount',
    'driveType',
    'engineCode',
    'exteriorColorCode',
    'interiorColorCode',
    'make',
    'modelVersion',
    'packageOptionCodes',
    'parentModel',
    'trim',
    'truckBodyStyle',
    'year',
    'zipcode'
  ]);
}
